enum ModGroupDisplayStyle {
  Carousel = 'carousel',
  Default = 'default',
  LargeImage = 'large-image',
  Quantity = 'quantity',
  RowSizeGroup = 'row-size-group',
  SizeGroup = 'size-group',
  Slider = 'slider',
}

export { ModGroupDisplayStyle };
